import { render, staticRenderFns } from "./LoginV3.vue?vue&type=template&id=536af577&scoped=true"
import script from "./LoginV3.vue?vue&type=script&lang=js"
export * from "./LoginV3.vue?vue&type=script&lang=js"
import style0 from "./LoginV3.vue?vue&type=style&index=0&id=536af577&prod&lang=less&scoped=true"
import style1 from "./LoginV3.vue?vue&type=style&index=1&id=536af577&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536af577",
  null
  
)

export default component.exports